import { render, staticRenderFns } from "./CityDistrict.vue?vue&type=template&id=7a2fa8b8&"
import script from "./CityDistrict.vue?vue&type=script&lang=js&"
export * from "./CityDistrict.vue?vue&type=script&lang=js&"
import style0 from "./CityDistrict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CityDistrict.vue"
export default component.exports